import { createBrowserClient } from './pocketbase';
import { UsersRecord, UsersResponse } from '../types/pocketbase-types';
import { AuthModel } from 'pocketbase';
import { parse } from 'cookie';

export const authenticatedPbBrowserFromCookie = async () => {
  // this works for the edge runtime
  const pb = createBrowserClient();
  try {
    const cookie = parse(document.cookie ?? '');
    pb.authStore.loadFromCookie(`pb_auth=${cookie['pb_auth']}` ?? '');
    // await pb.collection("users").authRefresh()
    // console.log('in auth after2', pb, cookie, pb.authStore)

    // get an up-to-date auth store state by verifying and refreshing the loaded auth model (if any)
    // pb.authStore.isValid && (await pb.collection("users").authRefresh());
  } catch (_) {
    // clear the auth store on failed refresh
    pb.authStore.clear();
  }
  if (!pb.authStore.isValid) {
    throw new Error('Unauthorized');
  }

  const user: AuthModel = pb.authStore.model;
  const userTyped = user as UsersResponse<UsersRecord>;
  return { pb, user: userTyped };
};

export const authenticatedPbBrowserFromCredentials = async ({
  username,
  password,
}: {
  username: string;
  password: string;
}) => {
  const pb = createBrowserClient();
  try {
    await pb.collection('users').authWithPassword(username, password);
    const cookie = pb.authStore.exportToCookie({
      httpOnly: false,
      path: '/',
    });
    document.cookie = cookie;

    pb.authStore.loadFromCookie(cookie);
  } catch (_) {
    // clear the auth store on failed refresh
    pb.authStore.clear();
  }
  if (!pb.authStore.isValid) {
    throw new Error('Unauthorized');
  }

  const user: AuthModel = pb.authStore.model;
  const userTyped = user as UsersResponse<UsersRecord>;
  return { pb, user: userTyped };
};
